export function WaveDots() {
    return (
        <div className="flex items-center gap-[3px]">
            {[0, 1, 2].map((i) => (
                <div
                    key={i}
                    className="size-[5px] rounded-full bg-zinc-400 animate-dot-wave"
                    style={{ animationDelay: `${i * 0.15}s` }}
                />
            ))}
        </div>
    );
}
